
import { defineComponent } from 'vue';
import router from "@/router";
import ProjectItemComponent from "@/components/ProjectItemComponent.vue";
import {ProjectItem} from "@/models/ProjectItem";
import {Image} from "@/models/Image";
import {Credit} from "@/models/Credit";

export default defineComponent({
  name: 'RecentProjects',
  components: {
    ProjectItemComponent
  }  ,
  data(){
    return {
      projects: [] as ProjectItem[]
    }
  },
  mounted(){
    const lisanneImages = require.context('../assets/projects/geboorte/Geboorte_LISANNE/', false);
    const annaMarceloImages = require.context('../assets/projects/huwelijk/Huwelijk_ANNA & MARCELO/', false);
    const magaliYorickImages = require.context('../assets/projects/huwelijk/Huwelijk_MAGALI & YORICK/', false);
    const lilyImages = require.context('../assets/projects/geboorte/Geboorte_LILY/', false);
    const fullonImages = require.context('../assets/projects/branding/Branding_FULL ON/', false);
    const sieronImages = require.context('../assets/projects/branding/Branding_SIERON/', false);

    this.projects = [
      {
        id: 1,
        name:"Lisanne Bruyneel",
        category: "GEBOORTE",
        thumbnail: { id: 1, path: lisanneImages('./geboortekaart-op-maat-Lisanne-meisje-letterpress-groen-debossing-goudfolie-foliedruk-bosdieren-drukwerk-thumbnail.png')} as Image,
        images: [
          {
            id: 1, path: lisanneImages('./geboortekaart-op-maat-Lisanne-meisje-letterpress-groen-debossing-goudfolie-foliedruk-bosdieren-drukwerk-1.jpg')
          } as Image,
          {
            id: 2, path: lisanneImages('./geboortekaart-op-maat-Lisanne-meisje-letterpress-groen-debossing-goudfolie-foliedruk-bosdieren-drukwerk-2.jpg')
          } as Image,
          {
            id: 3, path: lisanneImages('./geboortekaart-op-maat-Lisanne-meisje-letterpress-groen-debossing-goudfolie-foliedruk-bosdieren-drukwerk-3.jpg')
          } as Image,
          {
            id: 4, path: lisanneImages('./geboortekaart-op-maat-Lisanne-meisje-letterpress-groen-debossing-goudfolie-foliedruk-bosdieren-drukwerk-4.jpg')
          } as Image
        ] as Image[],
        story: ['Het bos op een kaartje voor Lisanne. Afgewerkt met een diepgroene kleur op snee.'],
        technique: 'Foliedruk, Letterpress, Edge painting ',
      } as ProjectItem,
      {
        id: 2,
        name:"Anna & Marcelo",
        category: "HUWELIJK",
        thumbnail: { id: 1, path: annaMarceloImages('./huwelijksdrukwerk-drukwerk-annonce-trouwen-anna-marcelo-goudfolie-foliedruk-italian-wedding-thumbnail.png')} as Image,
        images: [
          {
            id: 1, path: annaMarceloImages('./huwelijksdrukwerk-drukwerk-annonce-trouwen-anna-marcelo-goudfolie-foliedruk-italian-wedding-1.jpg')
          } as Image,
          {
            id: 2, path: annaMarceloImages('./huwelijksdrukwerk-drukwerk-annonce-trouwen-anna-marcelo-goudfolie-foliedruk-italian-wedding-2.jpg')
          } as Image,
          {
            id: 3, path: annaMarceloImages('./huwelijksdrukwerk-drukwerk-annonce-trouwen-anna-marcelo-goudfolie-foliedruk-italian-wedding-3.jpg')
          } as Image,
        ] as Image[],
        story: ['Trouwen in het zonnige Italië, dan gaan we voor classy. Initialen-logo en een cute klein citroentje in goudfolie voor Anna & Marcelo.'],
        technique: 'Foliedruk, Offset'
      } as ProjectItem,
      {
        id: 3,
        name:"Full On - Your Full Event & Festival Crew Partner",
        category: "BRANDING",
        thumbnail: { id: 1, path: fullonImages('./branding-logo-huisstijl-full-on-eventsector-thumbnail.png')} as Image,
        images: [
          {
            id: 1, path: fullonImages('./branding-logo-huisstijl-full-on-eventsector-1.jpg')
          } as Image,
          {
            id: 2, path: fullonImages('./branding-logo-tshirt-textiel-huisstijl-full-on-eventsector-2.jpg')
          } as Image,
          {
            id: 3, path: fullonImages('./branding-logo-huisstijl-full-on-eventsector-3.jpg')
          } as Image,
          {
            id: 4, path: fullonImages('./branding-logo-belettering-carwrap-huisstijl-full-on-eventsector-4.jpg')
          } as Image,
          {
            id: 5, path: fullonImages('./branding-logo-huisstijl-full-on-toegangspass-5.jpg')
          } as Image,
        ] as Image[],
        story: ['Full On verzorgt crew op evenementen en festivals, van heftruckchauffeurs tot licht- en geluidstechniekers. Bij een bonte groep stagehands hoort dan ook een logo met ballen. Felle kleur verlopen en een herkenbaar beeldmerk waren hier dan ook volledig op hun plaats. Het beeldmerk is een combinatie van de F(ull) en de O(n) en bij het logo staat de ‘ON’ op een verhoogje om zo de actie weer te geven. '],
        customer: 'Overall event support - Catering crew - hospitality crew – stagehands',
        byCarte: 'Logo, Huisstijl'
      } as ProjectItem,
      {
        id: 4,
        name:"Lily Vandamme",
        category: "GEBOORTE",
        thumbnail: { id: 1, path: lilyImages('./geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-thumbnail.png')} as Image,
        images: [
          {
            id: 1, path: lilyImages('./geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-1.jpg')
          } as Image,
          {
            id: 2, path: lilyImages('./geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-2.jpg')
          } as Image,
          {
            id: 3, path: lilyImages('./geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-3.jpg')
          } as Image,
          {
            id: 4, path: lilyImages('./geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-4.jpg')
          } as Image,
        ] as Image[],
        story: ['Bloemetjes en roze voor Lily.'],
        technique: 'Letterpress, Offset',
      } as ProjectItem,
      {
        id: 5,
        name:"Sieron - Rise Above Your Body",
        category: "BRANDING",
        thumbnail: { id: 1, path: sieronImages('./branding-logo-huisstijl-sieron-rise-above-your-body-kinesitherapie-brakel-thumbnail.png')} as Image,
        images: [
          {
            id: 1, path: sieronImages('./branding-logo-huisstijl-sieron-rise-above-your-body-kinesitherapie-brakel-1.jpg')
          } as Image,
          {
            id: 2, path: sieronImages('./branding-logo-huisstijl-sieron-rise-above-your-body-kinesitherapie-brakel-2.jpg')
          } as Image,
          {
            id: 3, path: sieronImages('./branding-logo-huisstijl-social-media-templates-instagram-sieron-Kinesitherapie-brakel-3.jpg')
          } as Image,
        ] as Image[],
        story: ['Boordevol ideeën en passie voor zijn vak stampte Miguel, SIERON - Rise Above Your Body, uit de grond. Een totaalconcept waarbij een persoonlijke aanpak centraal staat, gericht op preventie van klachten. Carte Confituur ontwierp een krachtig logo met bijhorende branding. Sterke kleurencombinaties, beeldmerk en een strak logo gaven SIERON letterlijk kleur en vorm.'],
        customer: 'Kinesitherapeut - Manuele therapie - Massage - Dry Needling – Cupping',
        byCarte: 'Logo, Huisstijl, Social media templates'
      } as ProjectItem,
      {
        id: 6,
        name:"Magali & Yorick",
        category: "HUWELIJK",
        thumbnail: { id: 1, path: magaliYorickImages('./huwelijksdrukwerk-drukwerk-annonce-trouwen-magali-yorick-goudfolie-foliedruk-digitaal-crush-corn-kiwi-thumbnail.png')} as Image,
        images: [
          {
            id: 1, path: magaliYorickImages('./huwelijksdrukwerk-drukwerk-annonce-trouwen-magali-yorick-goudfolie-foliedruk-digitaal-crush-corn-kiwi-1.jpg')
          } as Image,
          {
            id: 2, path: magaliYorickImages('./huwelijksdrukwerk-drukwerk-annonce-trouwen-magali-yorick-goudfolie-foliedruk-digitaal-crush-corn-kiwi-2.jpg')
          } as Image,
          {
            id: 3, path: magaliYorickImages('./huwelijksdrukwerk-drukwerk-annonce-trouwen-magali-yorick-goudfolie-foliedruk-digitaal-crush-corn-kiwi-3.jpg')
          } as Image,
        ] as Image[],
        story: ['Deze lovebirds kozen voor foliedruk in witgoud op het mooie Crush papier en dat in twee kleurtjes, Kiwi en Corn.'],
        technique: 'Foliedruk, Offset'
      } as ProjectItem,
    ] as ProjectItem[]
  }
});
